<div class="container-fluid impactful-testcase h-100">
    @if(!loading) {
        @if(viewMode === 'all') {    
            @if(items.length) {
                <div class="d-flex flex-column h-100 pb-3">
                    <div class="d-flex justify-content-end p-2">
                        <button class="btn-accello-ternary btn-accello" [disabled]="selectedItems.length == 0" (click)="openDeleteConfirmationModal()">
                            <img src="assets/images/virtusa-icons/remove.png" alt="remove">
                            Delete Components
                        </button>
                    </div>
                    <div class="row row-cols-1 row-cols-md-3 pb-3 flex-grow-1 overflow-auto mb-3">
                        @for(item of getActive(items); track trackItem) {
                            <div class="card-wrapper mt-3">
                                <app-carousel-card [data]="item" (onEventEmit)="handleCardAction($event, item)"></app-carousel-card>
                            </div>
                        }
                    </div>
                </div>
            } @else {
                <div class="h-100">
                    <app-no-data></app-no-data>
                </div>
            }
        }
        
        @else if(viewMode === 'create') {
            <!-- <app-generate-mapping [data]="createdMappingData" (eventHandler)="handleActions($event)"></app-generate-mapping> -->
        }
    
        @else if(viewMode === 'edit') {
            <!-- <app-testcase-mapping-edit (onEventEmit)="handleActions($event)"></app-testcase-mapping-edit> -->
            <app-generate-mapping (onEventEmit)="handleActions($event)" [isEdit]=true [data]="createdMappingData" (eventHandler)="handleActions($event)" [selectedMode]="selectedType"></app-generate-mapping>
        }
    
        @else if(viewMode === 'impacted-testcase-analysis') {
            <app-impacted-test-case-analysis [view]="'impacted-testcase-analysis'" ></app-impacted-test-case-analysis>
        }
        @else if(viewMode === 'most-impacted-testcase-analysis') {
            <app-impacted-test-case-analysis [fileName]="fileName" [view]="'most-impacted-testcase-analysis'" ></app-impacted-test-case-analysis>
        }
    } @else {
        <app-loading [text]="'Loading data'"></app-loading>
    }
</div>